import { initializeApp, getApps } from "firebase/app";
import firebaseConfig from "@serie3/freelancesplaceapi/Config/Firebase/firebase";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { useRef, useState } from "react";
import { Modal } from "react-bootstrap";

// Reuse existing Firebase app — never initialise twice
const firebaseApp = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const auth = getAuth(firebaseApp);

const Forgot = ({ show, setShow }) => {
  const emailFieldRef = useRef(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const resetPassword = () => {
    const email = emailFieldRef.current.value;
    sendPasswordResetEmail(auth, email)
      .then(() => { setShowSuccess(true); setShowError(false); })
      .catch((error) => { setErrorMessage(error.message); setShowError(true); });
  };

  return (
    <Modal
      size="md"
      show={show}
      onHide={() => setShow(false)}
      centered
      animation={false}
      dialogClassName="lp-modal"
    >
      <Modal.Header closeButton className="lp-modal-header" />
      <Modal.Body className="lp-modal-body">
        <h2 className="lp-modal-title">Reset your password</h2>
        <p className="lp-modal-subtitle">
          Enter your email and we'll send you a reset link.
        </p>

        {showSuccess ? (
          <div className="lp-alert lp-alert-success">
            Check your inbox — a reset link is on its way.
          </div>
        ) : (
          <>
            <div className="lp-form-group">
              <label className="lp-form-label">Email</label>
              <input
                ref={emailFieldRef}
                type="email"
                placeholder="you@example.com"
                className="lp-form-input form-control"
              />
            </div>

            {showError && (
              <div className="lp-alert lp-alert-error">{errorMessage}</div>
            )}

            <button className="lp-form-submit" onClick={resetPassword}>
              Send reset link
            </button>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default Forgot;
